'use strict';

var app = app || angular.module('harriApp');


/**
 * SharedBrand data,
 * contains the brand Id in the checkout process
 */
app.factory('SharedBrand', ['$rootScope','$state','hEvent',function($rootScope,$state,hEvent){
  var brand = {
    brandId : '',
    url : ''
  };

  /**
   * Check page redirection
   */
  brand.checkRedirection = function() {

    // Reset the selected brand if the next page not a subscription page or checkout or pricing
    if ($rootScope.toState.state.name.indexOf('pricing') == -1 &&
      $rootScope.toState.state.name.indexOf('appLayout.harriSH.checkout') == -1) {

      brand.brandId = null;

    }

  }

  /**
   * Check if the user aborted the funnel
   */
  brand.checkUserAbort = function(){
    var stateArray = ['pricing', 'appLayout.harriSH.checkout', 'appLayout.harriSH.checkout.upgrade' , 'appLayout.harriSH.checkout.information' ];
    if( stateArray.indexOf( $state.current.name ) == -1 ){
      hEvent.track('CheckoutAbort',null,function(){});
    }

  }


  return brand;
}]);
